export class Board {
    constructor(eventsChannelFactory, id, gameId, playerId, cells) {
        this.eventsChannelFactory = eventsChannelFactory;
        this.id = id;
        this.gameId = gameId;
        this.playerId = playerId;
        this.cells = cells;
    }
    getEventsChannel() {
        return this.eventsChannelFactory.createEventsChannel(`board.${this.id}`);
    }
    getCell(number) {
        for (const cell of this.cells) {
            if ((cell === null || cell === void 0 ? void 0 : cell.number) === number) {
                return cell;
            }
        }
        return null;
    }
}
